import React from "react";

import { PathwayInput as Input } from "../../../_UI/StyledComponents/PathwayForm";
import { useSelector } from "react-redux";
import { PathwayFormGrid, PathwayFormGroup } from "../../../_UI/StyledComponents/PathwayForm";
import { Modes } from "../../../_statics/CRUDStatics";
import stringUtils from "../../../_services/string-utils";
import { PathwayLabel } from "../../../_UI/StyledComponents/PathwayForm";

const ClientSelectionForConnectedAuthData = (props) => {
    const clientReducer = useSelector((state) => state.client);

    return (
        <>
            <PathwayFormGroup>
                <PathwayLabel>Verfügbare Accounts & Shops</PathwayLabel>
                <Input
                    type="select"
                    name="type"
                    disable={clientReducer.editConnectedAuthDataMode === Modes.EDIT}
                    onChange={props.chooseExistingClient}
                    value={props.selectedClientForAuthData}
                >
                    <option value="">auswählen</option>
                    <option value="NEW_CLIENT">neuer Account / Shop</option>
                    {clientReducer.clients &&
                        clientReducer.clients.map((client, index) => (
                            <option key={index} value={client.externalUUID}>
                                {client.name}
                            </option>
                        ))}
                </Input>
            </PathwayFormGroup>
            {stringUtils.equals(props.selectedClientForAuthData, "NEW_CLIENT") && (
                <PathwayFormGrid>
                    <PathwayFormGroup>
                        <PathwayLabel>Name</PathwayLabel>
                        <Input
                            type="text"
                            name="name"
                            data-cy="name-field"
                            defaultValue={clientReducer.editClient.name}
                            onChange={props.handleEditClientChange}
                        />
                    </PathwayFormGroup>
                    <PathwayFormGroup>
                        <PathwayLabel>Notizen</PathwayLabel>
                        <Input
                            type="text"
                            name="note"
                            data-cy="note-field"
                            defaultValue={clientReducer.editClient.note}
                            onChange={props.handleEditClientChange}
                        />
                    </PathwayFormGroup>
                </PathwayFormGrid>
            )}
        </>
    );
};

export default ClientSelectionForConnectedAuthData;
